import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../api.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {Router, ActivatedRoute } from "@angular/router"
import { environment } from '../../../../environments/environment';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../_services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  /* public loginForm: FormGroup;
  public registerForm: FormGroup;
  submitted = false;
  public message:any = null; */
  

  /* constructor(private formBuilder: FormBuilder, private http: HttpClient, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) {

  } */

/* owlcarousel = [
    {
      title: "Welcome to HKBK",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
    },
    {
      title: "Welcome to HKBK",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
    },
    {
      title: "Welcome to HKBK",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
    }
  ]
  owlcarouselOptions = {
    loop: true,
    items: 1,
    dots: true
  }; */

  /* createLoginForm() {
    this.loginForm = this.formBuilder.group({
      userName: [''],
      password: [''],
    })
  }
  createRegisterForm() {
    this.registerForm = this.formBuilder.group({
      userName: [''],
      password: [''],
      confirmPassword: [''],
    })
  } */


  /* ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  } */

  /* get f() { return this.loginForm.controls; } */

  /* onSubmit(){
    // console.log(this.loginForm.value);
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }
    this.http.post<any>(this.api_endpoint+'/member', this.loginForm.value).subscribe(
      res => {
        // console.log(res.Error);
        if(res.Error){
          this.message = res.Error;
          return
        }
        console.log(res)
        sessionStorage.setItem('department', res.data.department);
        this.router.navigate(['adminhkbkcms/dashboard/default']);
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  } */

    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';

    constructor(
      private formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private authenticationService: AuthenticationService
  ) { 
      // redirect to home if already logged in
      if (this.authenticationService.currentUserValue) { 
          this.router.navigate(['/']);
      }
  }

  ngOnInit() {
      this.loginForm = this.formBuilder.group({
          username: ['', Validators.required],
          password: ['', Validators.required]
      });

      // get return url from route parameters or default to '/'
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || 'adminhkbkcms/dashboard/default';
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      if (this.loginForm.invalid) {
          return;
      }

      this.loading = true;
      this.authenticationService.login(this.f.username.value, this.f.password.value)
          .pipe(first())
          .subscribe(
              data => {
                if(data.Error){
                  this.error = data.Error;
                  this.loading = false;
                  return 0;
                }else{
                  this.router.navigate([this.returnUrl]);
                }
                  
              },
              error => {
                  this.error = error;
                  this.loading = false;
              });
  }
}

